// workplacegiving/html/js/corp-2021/src/home.js

import './_site-wide'
// import './shopraise-tracking-pixel'

// elements
const estimatedSavingsElems = document.getElementsByClassName('estimated-savings');
const employeeCountElem = document.getElementById('roi-mini-calc-employees');
const programCostElem = document.getElementById('bar-cost-amount');

// wierd constants
const calcConstants = [
  0.15 * 15000 * 0.10, // return from employees retained
  120000 * 0.01,       // productivity gained per employee
  3540 * 0.10,         // return from absenteeism reduction per employee
];
const PEPM = 2.00;      // per employee per month cost
const PEPY = PEPM * 12; // per employee per year cost


// Currency Formatter
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});


function calculate() {

  const employeeCount = parseInt(employeeCountElem.value) || 0;
  const estimatedSavings = Math.round(
      (employeeCount * calcConstants[0])
    + (employeeCount * calcConstants[1])
    + (employeeCount * calcConstants[2])
    , 0);

  const programCost = employeeCount * PEPY;

  Array.from(estimatedSavingsElems).forEach(elem => {
    elem.textContent = currencyFormatter.format(estimatedSavings);
  });

  programCostElem.textContent = currencyFormatter.format(programCost);
}

employeeCountElem.addEventListener('input', calculate);

calculate();